import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.jpg';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;

  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    text-align: justify;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div data-aos="fade-left" className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Pranay Sharma</span>
              </p>
              <h2 className="about__heading">
                AI/ML and Data Engineering Professional
              </h2>
              <div className="about__info">
                <PText>
                  I am an AI/ML and data engineering professional from
                  Rajasthan, India, currently pursuing an Integrated M.Tech in
                  Computer Science and Engineering at Vellore Institute of
                  Technology, Chennai.
                  <br /> <br />
                  As a PRISM Research Intern at Samsung R&amp;D, I engineer
                  fault-tolerant data processing pipelines with checkpointing,
                  quality validation, segmentation, transcription, and
                  metadata lineage across 227+ hours of heterogeneous data.
                  <br />
                  <br />
                  I also have production React.js experience from building
                  reusable components for B2B websites. My interests include
                  machine learning, LLMs, data integration, automation, and
                  building reliable software that creates measurable value.
                </PText>
              </div>
              <Button btnText="Download Resume" btnLink="https://drive.google.com/file/d/1wvrxe9PL121CjDZ6onRY4JfkeHd1Z2Qe/view?usp=sharing" />
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="Degree"
                items={[
                  'Integrated M.Tech in Computer Science and Engineering',
                  'VIT Chennai | GPA: 7.61 | 2022-2027',
                ]}
              />
              <AboutInfoItem
                title="Coursework"
                items={[
                  'Machine Learning',
                  'Deep Learning',
                  'NLP',
                  'DBMS',
                  'Data Structures',
                ]}
              />
              
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="Comfortable"
                items={[
                  'Python',
                  'SQL',
                  'C++',
                  'JavaScript',
                  'Pandas',
                  'NumPy',
                ]}
              />
              <AboutInfoItem
                title="AI / ML"
                items={[
                  'PyTorch',
                  'Scikit-learn',
                  'HuggingFace',
                  'NLP',
                  'LLM APIs',
                  'RAG',
                ]}
              />
              <AboutInfoItem
                title="Data"
                items={['PostgreSQL', 'MySQL', 'SQLite', 'ETL', 'Power BI']}
              />
              <AboutInfoItem
                title="Tools"
                items={[
                  'Git',
                  'Linux',
                  'FastAPI',
                  'Docker',
                  'AWS',
                  'Streamlit',
                ]}
              />
            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>

              <AboutInfoItem
                title="Samsung R&amp;D"
                items={['PRISM Research Intern', 'Nov 2025 - Present']}
              />
              <AboutInfoItem
                title="VPRS Technology"
                items={['ReactJS Developer', 'Jun 2025 - Jul 2025']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}